import { noop } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBlocker } from 'react-router-dom';

import { CustomSeverityDialog } from 'library/components/controls/dialogs/CustomSeverityDialog';

export const usePrompt = (
	message: string,
	when: boolean | (() => boolean) = true
) => {
	const [isOpen, setIsOpen] = useState(false);
	const { t } = useTranslation(['common', 'commonButton']);

	useEffect(() => {
		if (when === true) {
			window.onbeforeunload = () => message;
		} else if (typeof when === 'function') {
			window.onbeforeunload = () => (when() ? message : null);
		}

		return () => {
			window.onbeforeunload = null;
		};
	}, [message, when]);

	const handleConfirmExit = useCallback(() => {
		setIsOpen(true);
		return true;
	}, []);

	const checkIfBlocked = useCallback(() => {
		if (when === true || (typeof when === 'function' && when())) {
			return handleConfirmExit();
		}
		return false;
	}, [handleConfirmExit, when]);

	const { proceed = noop, reset = noop } = useBlocker(checkIfBlocked);

	const handleOnDecline = useCallback(() => {
		setIsOpen(false);
		reset();
	}, [reset]);

	const handleOnAccept = useCallback(() => {
		setIsOpen(false);
		proceed();
	}, [proceed]);

	return (
		<CustomSeverityDialog
			isOpen={isOpen}
			headerText={t('common:warning')}
			content={message}
			acceptButtonLabel={t('commonButton:yes')}
			declineButtonLabel={t('commonButton:cancel')}
			onDecline={handleOnDecline}
			onAccept={handleOnAccept}
		/>
	);
};
